const getHostName = () => {
  return window.location.hostname;
};

export default getHostName;
